import { render, staticRenderFns } from "./DocumentUploader.vue?vue&type=template&id=251495a8&"
import script from "./DocumentUploader.vue?vue&type=script&lang=js&"
export * from "./DocumentUploader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports